export const formatUSPhone = (phone?: string): string => {
  if (!phone) {
    return '';
  }

  const digits = phone.replace(/\D/g, '');

  // Only format valid US/Canada numbers
  if (digits.length !== 10) {
    return phone;
  }

  const area = digits.slice(0, 3);
  const prefix = digits.slice(3, 6);
  const line = digits.slice(6);

  return `(${area}) ${prefix}-${line}`;
};
